import { CheckOutlined, InfoCircleOutlined } from "@ant-design/icons";
import { useViewport } from "../../../../../hooks/useViewport";

/**
 * Една възможност във въпроса „Настани Иванови?" — „Една сметка / Отделна
 * сметка за всяка маса" и „Към коя сметка". Видът е на методите на плащане
 * в CloseTableModal: бяла карта, избраната — с топъл фон и отметка вдясно.
 * `warn` — описанието е причината възможността да е спряна.
 */
export const SeatOptionRow = ({
  title,
  meta,
  amount,
  checked,
  disabled = false,
  warn = false,
  onClick,
}: {
  title: string;
  meta: string;
  amount?: string;
  checked: boolean;
  disabled?: boolean;
  warn?: boolean;
  onClick: () => void;
}) => {
  const { isNarrow } = useViewport();
  return (
    <button
      type="button"
      role="radio"
      aria-checked={checked}
      disabled={disabled}
      onClick={onClick}
      className={`flex w-full min-w-0 items-center gap-3 border text-left transition-colors disabled:cursor-not-allowed ${
        isNarrow ? "rounded-[10px] px-3 py-2.5" : "rounded-xl px-4 py-3"
      } ${checked ? "border-pos-accent/30 bg-pos-ready-bg" : "cursor-pointer border-pos-line2 bg-pos-card"}`}
    >
      <span className="flex min-w-0 flex-1 flex-col gap-0.5">
        <span
          className={`break-words font-semibold leading-[1.3] ${isNarrow ? "text-[13.5px]" : "text-[15px]"} ${
            disabled && !checked ? "text-pos-muted" : checked ? "text-pos-accent-ink" : "text-pos-ink"
          }`}
        >
          {title}
        </span>
        <span
          className={`flex items-start gap-1.5 text-[12.5px] leading-[1.35] ${
            warn ? "font-semibold text-pos-accent-ink" : "text-pos-soft2"
          }`}
        >
          {warn && <InfoCircleOutlined className="mt-0.5 shrink-0" />}
          <span className="min-w-0 break-words">{meta}</span>
        </span>
      </span>
      {amount && <span className="shrink-0 font-pos-mono text-[14px] font-bold text-pos-ink">{amount}</span>}
      <span
        className={`inline-flex shrink-0 items-center justify-center rounded-full border text-white ${
          isNarrow ? "h-5 w-5" : "h-[22px] w-[22px]"
        } ${checked ? "border-pos-accent bg-pos-accent" : "border-pos-ctl bg-pos-card"}`}
      >
        {checked && <CheckOutlined className="text-[11px]" />}
      </span>
    </button>
  );
};
